import {Component, HostBinding, Input} from "@angular/core";

@Component({
  selector: 'int-empty-divider, [int-empty-divider]',
  template: ``,
  styles: [`
    :host {
      display: inline-block;
    }
  `]
})
export class IntEmptyDividerComponent {

  @Input() size: string | number = '1em';

  @HostBinding('style.min-width') get setMinWidth() {
    return this.sizeCalc
  }
  @HostBinding('style.width') get setWidth() {
    return  this.sizeCalc
  }
  @HostBinding('style.height') get setHeight() {
    return  this.sizeCalc
  }
  @HostBinding('style.min-height') get setMinHeight() {
    return this.sizeCalc
  }

  private get sizeCalc() {
    return typeof this.size === 'number' ? `${this.size}px` : this.size;
  }
}
